<template>
  <v-flex xs2 pt-1 class="d-flex justify-center">
    <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>
    <button @click="changeState"
            class="v-input theme--light v-input--selection-controls v-input--checkbox">
      <div class="v-input__control">
        <div class="v-input__slot">
          <div class="v-input--selection-controls__input">
            <div class="v-input--selection-controls__ripple accent--text">
            </div>
            <template v-if="inspectorModel == ''">
              <i aria-hidden="true" class="v-icon notranslate material-icons theme--light">check_box_outline_blank</i>
            </template>
            <template v-if="inspectorModel == 'yes'">
              <i aria-hidden="true" class="v-icon notranslate material-icons theme--light accent--text">check_box</i>
            </template>
            <template v-if="inspectorModel == 'no'">
              <i aria-hidden="true" class="v-icon notranslate material-icons theme--light">indeterminate_check_box</i>
            </template>
          </div>
        </div>
        <div class="v-messages theme--light">
          <div class="v-messages__wrapper">
          </div>
        </div>
      </div>
    </button>
  </v-flex>
</template>

<script>
import { validF } from '@/js/survey/validate/validF'
import HTTPresponse from '@/components/app/HTTPresponse'

export default {
  props: {
    answerid: String,
    input: Array | Object
  },
  components: {
    HTTPresponse: HTTPresponse
  },

  data () {
    return {
      inspectorModel: '',
      httpalert: false
    }
  },

  methods: {
    changeState () {
      if (this.inspectorModel === '') { this.inspectorModel = 'yes' }
      else if (this.inspectorModel === 'yes') { this.inspectorModel = 'no' }
      else if (this.inspectorModel === 'no') { this.inspectorModel = '' }

      this.validateF()
    },

    validateF () {
      // if (!this.$store.getters['auth/isAuthenticated']) return

      const params = {
        answerid: this.answerid,
        id: Array.isArray(this.input) ? this.input[0].id : this.input.id,
        // module: Array.isArray(this.input) ? this.input[0].id : this.input.id,
        value: this.inspectorModel,
        key: this.$route.params.validkey
      }

      validF(params)
        .then(response => {
          if (response.data.status === 'error') {
            this.httpalert = true
            setTimeout(() => {
              this.httpalert = false
            }, 4000)
          }
          else { this.$emit('inputUpdated') }
        })
        .catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    HTTPState (value) {
      this.httpalert = this.value
    }
  },

  mounted () {
    this.inspectorModel = this.input.validf ? this.input.validf : ''
  }
}
</script>
